<template>
<div class="content_buffet">
    <TypeBuffet v-if="typeMenu == 'buffet'" />
    <TypeALaCarte v-if="typeMenu == 'alacarte'" />
    <TypeDrink v-if="typeMenu == 'drink'" />
</div>
</template>

<script>
import TypeBuffet from '@/components/menuuser/menutype/TypeBuffet.vue'
import TypeALaCarte from '@/components/menuuser/menutype/TypeALaCarte.vue'
import TypeDrink from '@/components/menuuser/menutype/TypeDrink.vue'
export default {
    props: ['typeMenu'],
    components: {
        TypeBuffet,
        TypeALaCarte,
        TypeDrink,
    },
}
</script>

<style scoped>
.content_buffet {
    padding-top: 130px;
    padding-bottom: 100px;
}
</style>
